import { __ } from 'utils/form';
import * as yup from 'yup';

const valuationSchema = yup.object().shape({
  full_address: yup
    .string()
    .required(__('errors.full_address'))
    .typeError(__('errors.full_address')),
  zip: yup
    .string()
    .matches(/^[1-9]{1}[0-9]{3}$/, 'Wrong zip code')
    .required(__('errors.fill_field'))
    .typeError(__('errors.fill_field')),
  floor_number: yup
    .number()
    .required(__('errors.fill_field'))
    .typeError(__('errors.fill_field')),
  apartment_area: yup
    .number()
    .required(__('errors.fill_field'))
    .typeError(__('errors.fill_field'))
    .min(25, __('errors.values_within_range', { min: 25, max: 300 }))
    .max(300, __('errors.values_within_range', { min: 25, max: 300 })),
  condition_of_apartment: yup
    .string()
    .nullable()
    .required(__('errors.choose_one')),
  construction_year: yup
    .number()
    .required(__('errors.fill_field'))
    .typeError(__('errors.fill_field'))
    .min(1900, __('errors.values_within_range', { min: 1900, max: new Date().getFullYear() }))
    .max(new Date().getFullYear(), __('errors.values_within_range', { min: 1900, max: new Date().getFullYear() })),
  loggia_area: yup
    .mixed()
    .notRequired()
    .when('loggia', {
      is: true,
      then: yup
        .number()
        .required(__('errors.fill_field'))
        .typeError(__('errors.fill_field')),
    }),
  terrace_area: yup
    .mixed()
    .notRequired()
    .when('terrace', {
      is: true,
      then: yup
        .number()
        .required(__('errors.fill_field'))
        .typeError(__('errors.fill_field')),
    }),
  garden_area: yup
    .mixed()
    .notRequired()
    .when('garden', {
      is: true,
      then: yup
        .number()
        .required(__('errors.fill_field'))
        .typeError(__('errors.fill_field')),
    }),
  parking: yup
    .string()
    .nullable()
    .required(__('errors.choose_one')),
  heating_system: yup
    .string()
    .nullable()
    .required(__('errors.choose_one')),
});

export default valuationSchema;
